'use client';
import React from 'react';
import { PricingHero } from './PricingHero';
import { PricingTiers } from '../pricingSection/PricingTiers';
import { CircleWrapper } from '../backgrounds/CircleWrapper';
import { PricingModeSelector } from '../pricingSection/elements/PricingModeSelector';
import { PricingAttributeTable } from '../pricingAttributes/PricingAttributeTable';

interface IPricingPage {}

export const PricingPage: React.FC<IPricingPage> = () => {
    return (
        <div className="relative flex w-screen flex-col gap-32 md:gap-52">
            <PricingHero />
            <div className="relative flex w-full flex-col gap-1">
                <PricingModeSelector />
                <PricingTiers />
            </div>
            <div className="px-4">
                <PricingAttributeTable />
            </div>

            <div className="opacity-30">
                <CircleWrapper left={'30%'} top={'400px'} />
            </div>
        </div>
    );
};
